export const getRankIconUrl = (tierName: string): string => {
  return `/images/ranks/${tierName}.png`
}
